import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  deleteBilateralTrade,
  listBilateralTrades,
} from '@ebalance/proto/bffuser/v1/supply_bilateral_trade_service-SupplyBilateralTradeService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 相対取引削除 mutation hook。
 * onSuccess で list query を invalidate してテーブルを最新化する。
 */
export function useDeleteBilateralTrade(): InvalidatingMutationResultFor<
  typeof deleteBilateralTrade
> {
  return useInvalidatingMutation(deleteBilateralTrade, [
    createConnectQueryKey({
      schema: listBilateralTrades,
      cardinality: 'finite',
    }),
  ])
}
